<template>
  <div class="addmodal fixed w-full h-screen z-20 top-0 left-0 flex justify-center items-start overflow-auto">
    <div class="bg-white m-auto w-9/12 md:w-7/12 h-auto flex flex-col rounded-md justify-center items-center">
      <h2
        class="font-costea w-11/12 px-2 py-1 my-4 mx-auto border-b border-gray-200 text-left text-t20 font-medium text-costeaBlack">
        Crear nueva área
      </h2>
      <div class="bg-gray-200 w-11/12 h-24 rounded-md relative mb-4"
        :style="`background-repeat: no-repeat; background-size: contain; background-position:center center; ${showImage}`">
        <span @click="$refs.myFiles.click()"
          class="cursor-pointer flex flex-row items-center justify-center absolute bg-costeaPrimary text-white w-10 h-10 right-4 bottom-4 rounded-full">
          <i class="ri-camera-fill text-lg"></i>
          <input type="file" @input="pickFile" @change="onSelectedImage" ref="myFiles" style="display:none" />
        </span>
      </div>

      <p v-if="errorSizeImage"
        class="text-costeaSalmon font-costea text-t12 text-left w-11/12 bg-costeaSalmonDisabled px-2 py-1 rounded-md ">
        {{ this.errorSizeImage }}</p>

      <form @submit.prevent="validateForm" class="flex flex-col justify-start items-center w-11/12">

        <div class="flex items-center justify-between w-full flex-col sm:flex-row flex-wrap">
          <div class="mb-2 px-2 py-2 flex flex-col content-center items-center w-full rounded-md">
            <p for="nombre" class="w-full text-costeaGray items-center content-center text-t16 mb-1">Nombre del área: *
            </p>
            <input id="nombre" type="text" name="nombre" v-model="name" required
              class="bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-2 text-t16 w-full rounded-md tracking-wide"
              placeholder="Nombre del área">
          </div>
        </div>

        <div class="flex items-center justify-between w-full flex-col sm:flex-row flex-wrap">
          <div class="mb-2 px-2 py-2 flex flex-row content-center items-center w-10/12 sm:w-8/12 rounded-md">
            <div class="w-5/12 mr-2">
              <p for="diasHabiles" class="w-full text-costeaGray items-center content-center text-t16 mb-1">Días hábiles
                al mes: *</p>
              <input id="diasHabiles" type="number" min="0" max="30" name="diasHabiles" v-model="dias_habiles_mes"
                required
                class="bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-2 text-t16 w-full rounded-md tracking-wide"
                placeholder="Días hábiles al mes">
            </div>
            <div class="w-5/12">
              <p for="horasDia" class="w-full text-costeaGray items-center content-center text-t16 mb-1">Horas por día:
                *</p>
              <input id="horasDia" type="number" min="0" max="24" name="horasDia" v-model="horas_por_dia" required
                class="bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-2 text-t16 w-full rounded-md tracking-wide"
                placeholder="Horas por día">
            </div>
          </div>
          <div class="mb-2 px-2 py-2 flex flex-col content-center items-end w-10/12 sm:w-4/12 rounded-md">
            <p class="w-full text-costeaGray items-center content-center text-t16 mb-1 text-right">Horas hombre
              disponibles al mes:</p>
            <p>{{ this.getHorasHombre }} </p>
          </div>
        </div>

        <div class="flex items-center justify-between w-full flex-col sm:flex-row flex-wrap">
          <div class="mb-2 px-2 py-2 flex flex-row content-center items-center w-10/12 sm:w-8/12 rounded-md">
            <div class="w-10/12">
              <p for="costoArea" class="w-full text-costeaGray items-center content-center text-t16 mb-1">Costo total
                del área: *</p>
              <span class="bg-white border border-gray-400 flex justify-center items-center px-2 rounded-md">
                $
                <input id="costoArea" name="costoArea" type="number" min="0" max="999999999" step="0.01"
                  v-model="costo_total_del_area" required
                  class="bg-white border-white placeholder-gray-300 border outline-none font-costea px-2 p-2 text-t16 w-full tracking-wide"
                  placeholder="Costo total del área">
              </span>
            </div>

          </div>
          <div class="mb-2 px-2 py-2 flex flex-col content-center items-end w-10/12 sm:w-4/12 rounded-md">
            <p class="w-full text-costeaGray items-center content-center text-t16 mb-1 text-right">Costo hora hombre:
            </p>
            <p>$ {{ getCostoHorasHombre == Infinity || isNaN(getCostoHorasHombre) ? 0 :
                interNumberFormat(getCostoHorasHombre)
            }}</p>
          </div>
        </div>

        <div class="flex items-center justify-between w-full flex-col sm:flex-row flex-wrap">
          <div class="mb-2 px-2 py-2 flex flex-row content-center items-center w-10/12 sm:w-8/12 rounded-md">
            <div class="w-5/12">
              <p for="numPersonas" class="w-full text-costeaGray items-center content-center text-t16 mb-1">N° de
                personas: *</p>
              <input id="numPersonas" name="numPersonas" type="number" min="0" max="999" step="1"
                v-model="numero_de_personas" required
                class="bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-2 text-t16 w-full rounded-md tracking-wide"
                placeholder="Numero de personas">
            </div>

          </div>
        </div>

        <div class="mb-4 p-2 flex content-center items-center w-10/12 rounded-md justify-end">
          <button
            class="bg-costeaBtn2 rounded-md text-costeaPrimary hover:bg-costeaBtn2Hover duration-100 ease-in px-2 py-3 cursor-pointer w-36 box-border text-t12 uppercase tracking-wide mr-4"
            @click="toggleModal()" type="button">Cancelar</button>
          <div v-show="this.buttonText == 'Creando...'"
            class="bg-costeaPrimary rounded-md text-white duration-100 ease-in px-2 py-3 cursor-pointer w-36 box-border text-t12 uppercase tracking-wide mr-4">
            Creando...</div>
          <button :disabled="this.disabledButton" v-show="this.buttonText == 'Crear' || this.buttonText == '¡Listo!'"
            :class="'rounded-md text-white hover:bg-costeaHover duration-100 ease-in px-2 py-3 cursor-pointer w-36 box-border text-t12 uppercase tracking-wide ml-4 ' + buttonBg"
            type="submit">{{ buttonText }}</button>
        </div>
      </form>

    </div>

  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      cop: false,
      usd: false,
      buttonText: 'Crear',
      buttonBg: 'bg-costeaPrimary',
      disabledButton: false,
      name: '',
      dias_habiles_mes: '',
      horas_por_dia: '',
      costo_total_del_area: '',
      numero_de_personas: '',
      tasaCompra: '',
      costoUSD: '',
      costoCOP: '',
      materiaPrima: '',
      modalAct: true,
      previewImage: null,
      sendButton: '',

      errorSizeImage: '',
    }
  },
  computed: {
    ...mapState(['costea']),
    getHorasHombre() {
      let diasHabiles = this.dias_habiles_mes
      let horasDia = this.horas_por_dia
      let horas = diasHabiles * horasDia
      return horas
    },
    getCostoHorasHombre() {
      let totalCostoArea = this.costo_total_del_area
      let horasDisponiblesMes = this.getHorasHombre
      let trabajadoresArea = this.numero_de_personas
      let costo = totalCostoArea / (horasDisponiblesMes * trabajadoresArea)
      costo = costo.toFixed(2)
      return costo
    },
    showImage() {
      if (this.previewImage != null) {
        return `background-image:url('${this.previewImage}');`
      } else {
        return 'background-color: #f1f2f3;'
      }
    },
  },
  methods: {
    interNumberFormat(number) {
      let interNF = new Intl.NumberFormat('es-CO');
      let numberDecimals = parseFloat(number)
      numberDecimals = numberDecimals.toFixed(2)
      return interNF.format(numberDecimals)
    },
    onSelectedImage(event) {
      this.picture = event.target.files[0]
    },
    pickFile() {
      let input = this.$refs.myFiles
      let file = input.files
      if (file && file[0]) {
        let reader = new FileReader
        reader.onload = e => {
          this.previewImage = e.target.result
        }
        reader.readAsDataURL(file[0])
      }
    },
    validateForm() {
      this.buttonText = 'Creando...'
      this.setAreas()
    },
    setAreas: function () {
      this.errorSizeImage = ''
      if (this.picture && this.picture.size > 450000) {
        this.errorSizeImage = 'El tamaño de la imagen no puede ser mayor a 450kb'

        this.buttonText = 'Crear'
        this.disabledButton = false
        this.buttonBg = 'bg-costeaPrimary'
        return
      }

      let config = {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token'),
          'Content-Type': 'multipart/form-data'
        }
      }
      let formData = new FormData()
      if (this.picture != null) {
        formData.append('picture', this.picture);
      }
      formData.append('name', this.name);
      formData.append('dias_habiles_mes', parseInt(this.dias_habiles_mes))
      formData.append('horas_por_dia', parseInt(this.horas_por_dia))
      formData.append('horas_hombre_por_mes', parseInt(this.getHorasHombre))
      formData.append('costo_total_del_area', parseFloat(this.costo_total_del_area))
      formData.append('numero_de_personas', parseInt(this.numero_de_personas))

      axios
        .post(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}areasempresa-add`,
          formData, config)
        .then(() => {
          setTimeout(() => {
            this.buttonText = 'Listo!'
            this.disabledButton = true
            this.buttonBg = 'bg-costeaDarkGreen'
            this.name = ''
            this.dias_habiles_mes = ''
            this.getHorasHombre = ''
            this.costo_total_del_area = ''
            this.numero_de_personas = ''
            this.horas_por_dia = ''
          }, 100)
          setTimeout(() => {
            this.toggleModal()
          }, 1000)
          setTimeout(() => {
            this.buttonText = 'Crear'
            this.disabledButton = false
            this.buttonBg = 'bg-costeaPrimary'
          }, 3000)
        }
        ).catch(
          (error) => {
            console.log(error)
          }
        );
    },
    modalActive() {
      this.modalAct = true
      this.modalAct == true ? this.modalAct = false : this.modalAct = true
      return this.modalAct
    },
    toggleModal() {
      this.$emit('closeModalAdd', this.modalActive())
      this.$emit('reloadData', true)
    },
    onProcess() {
      this.buttonText = 'Creando...'
      this.sendButton = 'cursor: not-allowed; pointer-events: none;'
    }
  }
}
</script>

<style scoped>
.addmodal {
  background: rgba(0, 0, 0, 0.6);
}
</style>